import { render, staticRenderFns } from "./pusalrec.vue?vue&type=template&id=b4ce7b0c&scoped=true&"
import script from "./pusalrec.vue?vue&type=script&lang=js&"
export * from "./pusalrec.vue?vue&type=script&lang=js&"
import style0 from "./pusalrec.vue?vue&type=style&index=0&id=b4ce7b0c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4ce7b0c",
  null
  
)

export default component.exports